module.exports = function(aggregationType) {
  if (aggregationType === 'SUM') return 'SUM'
  else if (aggregationType === 'AVERAGE') return 'AVG'
  else if (aggregationType === 'MEDIAN') return 'MED'
}
